export default {
    computed: {
        resource() {
            try {
                return this.$store.getters.resourceById(this.resourceId)
            } catch (e) {
                console.warn(e)
            }
        },
        resourceType() {
            return this.$store.getters.resourceTypeById(this.resource.resourceType.id)
        },
        resources() {
            return this.$store.getters.resources
        },
    },
}
